// extracted by mini-css-extract-plugin
export var glitch = "glitchText-module--glitch--iEFU1";
export var glitchText = "glitchText-module--glitchText--zP9hJ";
export var slide = "glitchText-module--slide--dMEZm";
export var slide1 = "glitchText-module--slide1--VmueF";